import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {getPosts} from './_requests'
import {PostModel} from './BlogModels'
import {Link} from 'react-router-dom'
import {BlogCard} from './BlogCard'
import {Helmet} from 'react-helmet-async'

const Blog: React.FC = () => {
  const intl = useIntl()
  const [posts, setPosts] = useState<PostModel[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true)
        const response = await getPosts('latest')
        setPosts(Array.isArray(response.data) ? response.data : [response.data])
      } catch (error) {
        setError(intl.formatMessage({id: 'BLOG.LOAD_ERROR'}))
      } finally {
        setLoading(false)
      }
    }

    fetchPosts()
  }, [])

  if (loading) {
    return <div>{intl.formatMessage({id: 'COMMON.LOADING'})}</div>
  }

  if (error) {
    return <div className='alert alert-danger'>{error}</div>
  }

  if (posts.length === 0) {
    return <div>{intl.formatMessage({id: 'BLOG.NO_POSTS'})}</div>
  }

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({id: 'BLOG.META.TITLE'})}</title>
        <meta name='description' content={intl.formatMessage({id: 'BLOG.META.DESC'})} />
        <meta property='og:title' content={intl.formatMessage({id: 'BLOG.META.TITLE'})} />
        <meta property='og:description' content={intl.formatMessage({id: 'BLOG.META.DESC'})} />
      </Helmet>
      <div className='row g-4'>
        {posts.map((post) => (
          <div key={post.id} className='col-12 col-sm-6 col-lg-4'>
            <BlogCard post={post} />
          </div>
        ))}
      </div>
    </>
  )
}

export {Blog}
